// extracted by mini-css-extract-plugin
export var breakpointXs = "550px";
export var colorGray = "#8e9287";
export var colorGrayDark = "#616161";
export var colorGrayDarker = "#272824";
export var colorGrayLight = "#e3e4e2";
export var colorGrayLighter = "#f2f3f2";
export var colorPrimary = "#a6ce3c";
export var colorSecondary = "#4f7802";
export var footer = "Footer-module--footer--2d913";
export var legalLinks = "Footer-module--legal-links--bf213";
export var link = "Footer-module--link--e0d8f";
export var logo = "Footer-module--logo--2eef9";
export var logoWrapper = "Footer-module--logo-wrapper--55d7f";
export var lower = "Footer-module--lower--b822e";
export var lowerContainer = "Footer-module--lower-container--38b5b";
export var menuWrapper = "Footer-module--menu-wrapper--66950";
export var spacingLg = "32px";
export var spacingMd = "32px";
export var spacingSm = "16px";
export var spacingXl = "128px";
export var spacingXs = "8px";
export var spacingXxs = "4px";
export var upper = "Footer-module--upper--78cf8";
export var upperContainer = "Footer-module--upper-container--edc9e";